/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable react/hook-use-state */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useContext, useEffect } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Loader } from "@progress/kendo-react-indicators";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardTitle,
  Combobox,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@repo/ui";
import {
  useAddCashToVault,
  useGetVaultCashCustomers,
  useUpdateCashLimit,
  useUpdateCustomerCashLimit,
} from "utils/apis/vault.api";
import { isOperationAllowed, showToast } from "utils/helper";
import Layout from "components/layout";
import { useGetCashCenters, useGetCustomers } from "utils/apis/lookups.api";
import { Link } from "react-router-dom";
import { UserContext } from "../../utils/reducers/user";
import AddCashToVault from "./add-cash-to-vault";
import { Permissions } from "utils/enums";

export default function VaultManagement() {
  const { CashCenterId } = useContext(UserContext);

  const [ddlCashCenters, setDdlCashCenters] = useState("");
  const [vaultLimit, setVaultLimit] = useState(0);
  const [txtVaultLimitColor, setTxtVaultLimitColor] = useState("");

  const [loaderPanel, setLoaderPanel] = useState("d-none");
  const [customersLimits, setCustomersLimits] = useState([]);

  const [ddlCustomers, setDdlCustomers] = useState<any>(null);
  const [customerLimit, setCustomerLimit] = useState(0);
  const [txtCustLimitColor, setCustLimitColor] = useState("");

  const [btnAddVaultDisabled, setBtnAddVaultDisabled] = useState(false);
  const [btnAddVaultText, setBtnAddVaultText] = useState("Save");

  const [btnAddCustLimitDisabled, setBtnAddCustLimitDisabled] = useState(true);
  const [btnAddCustLimitText, setBtnAddCustLimitText] = useState("Save");

  const [showAddCashToVaultModel, setShowAddCashToVaultModel] = useState(false);

  const [allowVaultUpdate] = useState(true);

  const { data: cashCenters, isSuccess: cashCenterSuccess } =
    useGetCashCenters();
  const { data: customers } = useGetCustomers();
  const {
    data: vaultCustomers,
    isSuccess: vaultCustomerSuccess,
    isError: vaultCustomerError,
    // refetch: refetchVaultLimits,
  } = useGetVaultCashCustomers();

  useEffect(() => {
    if (cashCenterSuccess) {
      const defaultCc = cashCenters.find(
        (c: any) => c.cashCenterId == CashCenterId
      );
      if (defaultCc) {
        setDdlCashCenters(defaultCc.cashCenterId);
      }
    }
  }, [cashCenterSuccess]);

  useEffect(() => {
    if (vaultCustomerSuccess) {
      const { vaultInsuranceLimit, customersCash } = vaultCustomers;

      setVaultLimit(vaultInsuranceLimit);

      const limits: any = [];

      customersCash.forEach((v: any) => {
        const { customerId, name, limit, customerCash } = v;

        const notesBreakdown: any = [];
        const coinsBreakdown: any = [];
        const netTotals: any = [];

        customerCash.forEach((dnm: any) => {
          const currency = dnm.denomination.split(" ")[0];
          const multiple = parseFloat(dnm.denomination.split(" ")[1]);
          const shape = dnm.shape;

          const currencyFound = netTotals.find(
            (nt: any) => nt.currency == currency
          );

          if (shape == "Notes") {
            const notesFound = notesBreakdown.find(
              (c: any) => c.currency == currency && c.shape == "Notes"
            );

            if (notesFound) {
              const totalNotes =
                dnm.fit + dnm.cut + dnm.tap + dnm.damaged + dnm.rejected;

              notesFound.notes += totalNotes;

              if (currencyFound) {
                currencyFound.total += totalNotes * multiple;
              } else {
                const currObj = {
                  currency,
                  total: totalNotes * multiple,
                };

                netTotals.push(currObj);
              }
            } else {
              const totalNotes =
                dnm.fit + dnm.cut + dnm.tap + dnm.damaged + dnm.rejected;

              const cashObj = {
                currency,
                shape,
                notes: totalNotes,
              };

              notesBreakdown.push(cashObj);

              if (currencyFound) {
                currencyFound.total += totalNotes * multiple;
              } else {
                const currObj = {
                  currency,
                  total: totalNotes * multiple,
                };

                netTotals.push(currObj);
              }
            }
          } else if (shape == "Coins") {
            const coinsFound = coinsBreakdown.find(
              (c: any) => c.currency == currency && c.shape == "Coins"
            );

            if (coinsFound) {
              const totalCoins =
                dnm.fit + dnm.cut + dnm.tap + dnm.damaged + dnm.rejected;
              coinsFound.coins += totalCoins;

              if (currencyFound) {
                currencyFound.total += totalCoins * multiple;
              } else {
                const currObj = {
                  currency,
                  total: totalCoins * multiple,
                };

                netTotals.push(currObj);
              }
            } else {
              const totalCoins =
                dnm.fit + dnm.cut + dnm.tap + dnm.damaged + dnm.rejected;

              const cashObj = {
                currency,
                shape,
                coins: totalCoins,
              };

              coinsBreakdown.push(cashObj);

              if (currencyFound) {
                currencyFound.total += totalCoins * multiple;
              } else {
                const currObj = {
                  currency,
                  total: totalCoins * multiple,
                };

                netTotals.push(currObj);
              }
            }
          }
        });

        const limitObj = {
          customerId,
          customer: name,
          limit,
          customerCash,
          notesBreakdown,
          coinsBreakdown,
          netTotals,
        };

        limits.push(limitObj);
      });

      setCustomersLimits(limits);
      setLoaderPanel("d-none");
    }
    if (vaultCustomerError) {
      setCustomersLimits([]);
      setVaultLimit(0);
      showToast("error", "No vault found for selected cash center.");
      setLoaderPanel("d-none");
    }
  }, [vaultCustomerSuccess, vaultCustomerError, vaultCustomers]);

  function DenomTotalCell({ dataItem }: any) {
    const nf = Intl.NumberFormat();
    let totalValue = 0;
    Object.entries(dataItem).map(([key, value]: any) => {
      if (!["denomination", "shape", "counterfeit"].includes(key)) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return (totalValue = totalValue + value);
      }
      return totalValue + 0;
    });
    return (
      <td>
        <div>
          <span className="font-semibold inline-block whitespace-break-spaces">{`${dataItem?.denomination?.split(" ")[0]} ${nf.format(totalValue * dataItem?.denomination?.split(" ")[1])}`}</span>
          <br />
        </div>
      </td>
    );
  }

  function DetailComponent(props: any) {
    const data = props.dataItem.details;

    if (data) {
      return (
        <Grid data={data}>
          <Column field="denomination" title="Denomination" />
          <Column field="shape" title="Shape" />
          <Column field="fit" title="Fit" format="{0:N}" />
          <Column field="cut" title="Cut" format="{0:N}" />
          <Column field="tap" title="Tap" format="{0:N}" />
          <Column field="damaged" title="Damaged" format="{0:N}" />
          <Column field="rejected" title="Mixed Serial" format="{0:N}" />
          <Column field="counterfeit" title="Counterfeit" format="{0:N}" />
          <Column
            cell={DenomTotalCell}
            title="Total"
            format="{0:N}"
            width="fit-content"
          />
        </Grid>
      );
    }
    return null;
  }

  const expandChange = (event: any) => {
    event.dataItem.expanded = event.value;
    const limit = event.dataItem;

    setCustomersLimits([...customersLimits]);

    if (!event.value || event.dataItem.detail) {
      return;
    }

    const data: any = customersLimits.slice();

    const index = data.findIndex(
      (cl: any) => cl.customerId === limit.customerId
    );

    data[index].details = limit.customerCash;

    setCustomersLimits(data);
  };

  function TotalNotesCell({ dataItem }: any) {
    const nf = Intl.NumberFormat();

    return (
      <td>
        {dataItem.notesBreakdown.map((nt: any, i: any) => {
          return (
            <div key={i}>
              <span className="font-semibold">{`${nt.currency}: ${nf.format(
                nt.notes
              )}`}</span>
              <br />
            </div>
          );
        })}
      </td>
    );
  }

  function TotalCoinsCell({ dataItem }: any) {
    const nf = Intl.NumberFormat();
    return (
      <td>
        {dataItem.coinsBreakdown.map((tn: any, i: any) => {
          return (
            <div key={i}>
              <span className="font-semibold">{`${tn.currency}: ${nf.format(
                tn.coins
              )}`}</span>
              <br />
            </div>
          );
        })}
      </td>
    );
  }

  function NetTotalCell({ dataItem }: any) {
    const nf = Intl.NumberFormat();
    return (
      <td>
        {dataItem.netTotals.map((nt: any, i: any) => {
          return (
            <div key={i}>
              <span className="font-semibold">{`${nt.currency}: ${nf.format(
                nt.total
              )}`}</span>
              <br />
            </div>
          );
        })}
      </td>
    );
  }

  const onDdlCashCentersChanged = (value: string) => {
    setDdlCashCenters(value);
  };

  const onDdlCustomersChanged = (value: any) => {
    setDdlCustomers(value);
    const selCustomerLimit: any = customersLimits.find(
      (cl: any) => cl.customerId == value
    );

    if (selCustomerLimit) {
      setCustomerLimit(selCustomerLimit.limit);
      setBtnAddCustLimitDisabled(false);
    }
  };

  const {
    mutate: updateCashLimit,
    isSuccess: updateCashSuccess,
    isError: updateCashError,
  } = useUpdateCashLimit();

  const onBtnAddVaultClicked = () => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }

    if (vaultLimit == 0) {
      showToast("error", "Vault Insurance Limit is required");
      setTxtVaultLimitColor("text-error");
      return;
    }

    setTxtVaultLimitColor("");

    const upsertDto = {
      cashCenterId: ddlCashCenters,
      insuranceLimit: vaultLimit,
    };

    setBtnAddVaultDisabled(true);
    setBtnAddVaultText("Saving...");
    updateCashLimit(upsertDto);
  };

  useEffect(() => {
    if (updateCashSuccess) {
      setTxtVaultLimitColor("");
      setBtnAddVaultText("Save");
      setBtnAddVaultDisabled(false);
      showToast("success", "Vault info saved successfully!");
    }
    if (updateCashError) {
      showToast("error", "Failed to save vault info, please try again later.");
      setBtnAddVaultDisabled(false);
      setBtnAddVaultText("Save");
    }
  }, [updateCashSuccess, updateCashError]);

  const {
    mutate: updateCustomerCashLimit,
    isSuccess: updateCustomerCashSuccess,
    isError: updateCustomerCashError,
  } = useUpdateCustomerCashLimit();

  const onBtnCustomerLimitClicked = () => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }

    if (!ddlCustomers) {
      showToast("error", "Please select customer.");
      return;
    }

    if (customerLimit == 0) {
      showToast("error", "Customer's cash limit is required");
      setCustLimitColor("text-error");
      return;
    }

    setCustLimitColor("");

    const upsertDto = {
      cashCenterId: ddlCashCenters,
      customerId: ddlCustomers,
      cashLimit: customerLimit,
    };

    setBtnAddCustLimitDisabled(true);
    setBtnAddCustLimitText("Saving...");
    updateCustomerCashLimit(upsertDto);
  };

  useEffect(() => {
    if (updateCustomerCashSuccess) {
      setCustomerLimit(0);
      setDdlCustomers(null);
      setBtnAddCustLimitText("Save");
    }
    if (updateCustomerCashError) {
      setBtnAddCustLimitDisabled(false);
      setBtnAddCustLimitText("Save");
    }
  }, [updateCustomerCashSuccess, updateCustomerCashError]);

  const toggleAddCashModel = () => {
    setShowAddCashToVaultModel(!showAddCashToVaultModel);
  };

  const { mutate: addCashToVault, isSuccess: addCashToVaultSuccess } =
    useAddCashToVault();

  const onBtnAddCashClicked = (addedCash: any) => {
    const { cashCenterId, customerId, customerCash } = addedCash;

    const cash = customerCash.map((cc: any) => ({
      denomination: `${cc.denomination.split(" ")[0]} ${cc.denomination.split(" ")[1]}`,
      shape: cc.shape,
      version: "",
      count: cc.count,
    }));

    const fitCashDto = {
      cashCenterId,
      customerId,
      cash,
    };

    addCashToVault(fitCashDto);
  };

  useEffect(() => {
    if (addCashToVaultSuccess) {
      toggleAddCashModel();
    }
  }, [addCashToVaultSuccess]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Vault Management</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent className="pt-6">
          <div className="flex gap-4 mb-5">
            <div className="ml-auto">
              <div className={`text-end ${loaderPanel}`}>
                <Loader size="large" type="pulsing" />
              </div>
            </div>
          </div>

          <div className="flex gap-4">
            <div className={!allowVaultUpdate ? "w-full" : "w-[75%]"}>
              <Card>
                <CardTitle className="text-center text-lg py-3 text-secondary bg-secondary/25">
                  {` Customers' Cash Breakdwon in Main Vault`}
                </CardTitle>
                {allowVaultUpdate && isOperationAllowed("Vault", "Add") ? (
                  <>
                    <div className="flex p-3">
                      <div className="w-[25%]">
                        {/* <Button
                          variant="secondary"
                          className="w-full"
                          onClick={toggleAddCashModel}
                        >
                          Add Cash to Vault
                        </Button> */}
                      </div>

                      <div className="w-[75%]">
                        <div className={`text-end ${loaderPanel}`}>
                          <Loader size="large" type="pulsing" />
                        </div>
                      </div>
                    </div>

                    <div className="border-b bg-accent" />
                  </>
                ) : null}
                <div className="p-3">
                  <Grid
                    data={customersLimits}
                    detail={DetailComponent}
                    expandField="expanded"
                    onExpandChange={expandChange}
                  >
                    <Column
                      field="customer"
                      title="Customer"
                      className="font-semibold"
                    />

                    <Column
                      field="limit"
                      title="Cash Limit"
                      format="{0:N}"
                      className="font-semibold"
                    />

                    <Column
                      field="totalNotes"
                      title="Notes Breakdown"
                      filterable={false}
                      className="text-left"
                      cell={TotalNotesCell}
                    />

                    <Column
                      field="totalCoins"
                      title="Coins Breakdown"
                      filterable={false}
                      cell={TotalCoinsCell}
                    />

                    <Column
                      field="netTotals"
                      title="Net Total"
                      filterable={false}
                      cell={NetTotalCell}
                    />
                  </Grid>
                </div>
              </Card>
            </div>
            <div className="w-[25%]">
              <Card>
                <CardTitle className="text-center text-lg py-3 text-secondary bg-secondary/25">
                  Add/Update Vault Insurance Limit
                </CardTitle>
                <CardContent className="p-3">
                  <Combobox
                    placeholder="Select Cash Center"
                    value={ddlCashCenters}
                    setValue={onDdlCashCentersChanged}
                    data={cashCenters?.map((item) => ({
                      value: item.cashCenterId,
                      label: item.name,
                    }))}
                  />
                  <div className="mt-3">
                    <label className="font-semibold leading-none">
                      Vault Insurance Limit
                    </label>
                    <NumericTextBox
                      step={0}
                      spinners={false}
                      placeholder="Main Vault Insurance Limit"
                      className={`w-full h-10 ${txtVaultLimitColor}`}
                      value={vaultLimit}
                      onChange={(e: any) => {
                        setVaultLimit(e.target.value);
                      }}
                      onWheel={(event: any) => {
                        event.stopPropagation();
                      }}
                    />
                  </div>
                  {isOperationAllowed(Permissions.Vault, Permissions.Edit) ? (
                    <Button
                      disabled={btnAddVaultDisabled}
                      variant="secondary"
                      className="w-full mt-3"
                      onClick={onBtnAddVaultClicked}
                    >
                      {btnAddVaultText}
                    </Button>
                  ) : null}
                </CardContent>
              </Card>
              <Card className="mt-2">
                <CardTitle className="text-center text-lg py-3 text-secondary bg-secondary/25">
                  Add/Update Customer Insurance Limit
                </CardTitle>
                <CardContent className="p-3">
                  <Combobox
                    placeholder="Select Customer"
                    value={ddlCustomers}
                    setValue={onDdlCustomersChanged}
                    data={customers?.map((item) => ({
                      value: item.customerId,
                      label: item.name,
                    }))}
                  />
                  <div className="my-3">
                    <label className="font-semibold leading-none">
                      {`Customer's Cash Limit`}
                    </label>
                    <NumericTextBox
                      step={0}
                      spinners={false}
                      placeholder="Customer Cash Limit"
                      className={`w-100 h-10 ${txtCustLimitColor}`}
                      value={customerLimit}
                      onChange={(e: any) => {
                        setCustomerLimit(e.target.value);
                      }}
                    />
                  </div>
                  {isOperationAllowed(Permissions.Vault, Permissions.Edit) ? (
                    <Button
                      disabled={btnAddCustLimitDisabled}
                      variant="secondary"
                      className="w-full"
                      onClick={onBtnCustomerLimitClicked}
                    >
                      {btnAddCustLimitText}
                    </Button>
                  ) : null}
                </CardContent>
              </Card>
            </div>
          </div>
        </CardContent>
      </Card>
      <Dialog open={showAddCashToVaultModel} onOpenChange={toggleAddCashModel}>
        <DialogContent className="max-w-[900px]">
          <DialogHeader>
            <DialogTitle>Add Cash To Vault</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-4 overflow-auto max-h-[80vh]">
            <AddCashToVault addCashHandler={onBtnAddCashClicked} />
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </Layout>
  );
}
